import { BreakpointObserver } from '@angular/cdk/layout';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';

import { SideCollapsedMaxWidth, TopCollapsedMaxWidth } from '@/app/shared/constants/constant';
import { ThemeService } from '@core/services/store/common-store/theme.service';
import {
  EquipmentWidth,
  WindowsWidthService,
} from '@core/services/store/common-store/windows-width.service';

/*Service theo dõi độ rộng màn hình*/
@Injectable({
  providedIn: 'root',
})
export class SubWindowWithService {
  subWidthObj: Record<string, [EquipmentWidth, [number, number]]> = {
    '(max-width: 575.98px)': [EquipmentWidth.xs, [0, 575.98]],
    '(min-width: 576px) and (max-width: 767.98px)': [EquipmentWidth.sm, [576, 767.98]],
    '(min-width: 768px) and (max-width: 991.98px)': [EquipmentWidth.md, [768, 991.98]],
    '(min-width: 992px) and (max-width: 1199.98px)': [EquipmentWidth.lg, [992, 1199.98]],
    '(min-width: 1200px) and (max-width: 1599.98px)': [EquipmentWidth.xl, [1200, 1599.98]],
    '(min-width: 1600px)': [EquipmentWidth.xxl, [1600, 9999]],
  };
  private destroyRef = inject(DestroyRef);
  private winWidthService = inject(WindowsWidthService);
  private breakpointObserver = inject(BreakpointObserver);
  private themesService = inject(ThemeService);
  // todo sửa signal
  themesOptions$ = toObservable(this.themesService.$themesOptions);
  // Theo dõi theme (top hay side), xác định độ rộng tối thiểu cho chế độ over
  subWidthForTheme(): void {
    this.themesOptions$
      .pipe(
        switchMap((res) => {
          let maxWidth = '';
          if (res.mode === 'side' || (res.mode === 'mixin' && !res.splitNav)) {
            maxWidth = `(max-width: ${SideCollapsedMaxWidth}px)`;
          } else if (res.mode === 'top' || (res.mode === 'mixin' && res.splitNav)) {
            maxWidth = `(max-width: ${TopCollapsedMaxWidth}px)`;
          }
          // Có thể truyền tham số [Breakpoints.Small, Breakpoints.XSmall]
          return this.breakpointObserver.observe([maxWidth]);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result) => {
        const isOverMode = result.matches;
        this.themesService.$isOverModeTheme.set(isOverMode);
        // Là chế độ over, mở rộng/thu gọn menu bên trái
        if (isOverMode) {
          this.themesService.$isCollapsed.set(false);
        }
      });
  }

  // Dựa vào độ rộng màn hình truyền vào để xác định nút lưới nào
  judgeWindowsWidth(width: number): EquipmentWidth {
    let currentPoint: EquipmentWidth;
    Object.values(this.subWidthObj).forEach((item) => {
      if (width >= item[1][0] && width <= item[1][1]) {
        currentPoint = item[0];
      }
    });
    return currentPoint!;
  }

  // Theo dõi độ rộng trình duyệt cho hệ thống lưới chung
  subWidthForStore(): void {
    this.breakpointObserver
      .observe(Object.keys(this.subWidthObj))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        Object.keys(res.breakpoints).forEach((item) => {
          if (res.breakpoints[item]) {
            this.winWidthService.$windowWidth.set(this.subWidthObj[item][0]);
          }
        });
      });
  }

  subWindowWidth(): void {
    this.subWidthForTheme();
    this.subWidthForStore();
    // Khởi tạo thì set node hiện tại
    this.winWidthService.$windowWidth.set(this.judgeWindowsWidth(window.innerWidth));
  }
}
